import { styled, Chip, ChipProps } from '@mui/material';

export const StyledDataChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'chipColor'
})<ChipProps & { chipColor: 'success' | 'error' | 'secondary' }>(
  ({ theme, chipColor = 'secondary' }) => ({
    backgroundColor: theme.vars.palette[chipColor].container,
    color: theme.vars.palette[chipColor].onFixedVariant,
    fontSize: '13px',
    padding: theme.spacing(0, 0.5)
  })
);
